var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"src":require("@/assets/imgs/update/map-static.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(" 1.‌自驾游‌：可以使用导航搜索“顺昌县博物馆”，根据导航指示前往目的地。"),_c('br'),_vm._v(" 2.公交车‌：居民可以乘坐1路、3路、7路、8路、9路、15路公交车，到达塔山站。营业时间为06:15—20:40"),_c('br'),_vm._v(" 附近公交站点2个，双向均为塔山站。（2个停车场；35个车位） ")])])
}]

export { render, staticRenderFns }